import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { submitReturn } from "@/lib/offline";
import { CYLINDERS } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Stepper } from "@/components/Stepper";
import { toast } from "sonner";

export default function Returns() {
  const navigate = useNavigate();
  const [counts, setCounts] = useState({ DOM_14_2: 0, COM_19: 0, KG_5: 0, FTL_5: 0 });
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const total = Object.values(counts).reduce((a, b) => a + b, 0);

  const save = async () => {
    const items = CYLINDERS.filter((c) => counts[c.code] > 0).map((c) => ({ cylinder_type: c.code, qty: counts[c.code] }));
    if (items.length === 0) { toast.error("Add at least one unsold cylinder"); return; }
    setBusy(true);
    try {
      const res = await submitReturn({ items, empties_collected: 0, reason });
      toast.success(res.queued ? "Saved on phone — will sync when online" : "Returns recorded");
      navigate("/driver");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-4 fade-up">
      <h1 className="font-head text-xl font-bold">Returns</h1>
      <p className="text-sm text-muted-foreground">Unsold full cylinders going back to stock. (Empties are recorded on the delivery screen.)</p>
      <div className="space-y-3">
        {CYLINDERS.map((c) => (
          <Card key={c.code} className="p-4 flex items-center justify-between">
            <div className="font-medium">{c.label}</div>
            <Stepper value={counts[c.code]} onChange={(v) => setCounts({ ...counts, [c.code]: v })} testid={`return-stepper-${c.code}`} />
          </Card>
        ))}
        <div><Label>Reason (optional)</Label><Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. customers not home" data-testid="return-reason-input" /></div>
      </div>
      <div className="fixed bottom-0 inset-x-0 max-w-md mx-auto p-4 bg-background/95 backdrop-blur border-t">
        <Button className="w-full h-14 text-base" onClick={save} disabled={busy} data-testid="driver-returns-save-button">Save returns · {total} cylinders</Button>
      </div>
    </div>
  );
}
